<template lang="pug">
    div.individual-chart(:class="wrapperClass")
        v-chart(:option="chartDataSourcesAllocation" autoresize :class="className")
        
</template>

<script>
import { ACTIVITY_SOURCES } from '@/utils/constants'

const SOURCES_COLORS = {
    AudienceBootstrap: '#42d4f4',
    Collect: '#645AFF',
    CustomSegmentBootstrap: '#dcbeff',
    CustomSegmentFrequency: '#fabed4',
    CustomSegmentRemoval: '#fffac8',
    DataEntryManager: '#469990',
    DataService: '#800000',
    GenericCollect: '#7AABD1',
    GenericCollectGCP: '#ffd8b1',
    Marketplace: '#9a6324',
    Other: '#796BF4',
    WeboramaTaxonomies: '#33A6FF',
    WCM: '#2DC9EB'
}
const OTHERS_DEFAULT_COLORS = ['#e6194b', '#3cb44b', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff']

export default {
    props: {
        allocationMetrics: { type: Object, required: true },
        className: { type: String, required: false, default: '' }
    },

    computed: {
        wrapperClass() {
            return this.className + '-wrapper'
        },
        chartDataSourcesAllocation() {
            return {
                tooltip: {
                    show: true
                },
                legend: {
                    left: '0',
                    orient: 'vertical',
                    top: '0%',
                    show: true,
                    textStyle: {
                        fontSize: 14,
                        fontFamily: 'weborama',
                        color: '#000000'
                    },
                    data: Object.keys(this.allocationMetrics.allocationBySignificantProvider),
                    tooltip: {
                        trigger: 'item',
                        show: true,
                        alwaysShowContent: true,
                        showContent: true,
                        extraCssText: 'max-width: 300px; padding: 10px; white-space: unset; word-break: break-word',
                        formatter({ name }) {
                            if (name === 'Other') return 'Other sources'
                            const fullObject = Object.values(ACTIVITY_SOURCES).find(item => item.source === name)
                            return `${fullObject.hint}`
                        }
                    }
                },
                series: [
                    {
                        name: 'Account audience allocation by source',
                        type: 'pie',
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: '#fff',
                            borderWidth: 0,
                            color: ({ dataIndex, data }) => SOURCES_COLORS[data.name.replaceAll(' ', '')] || OTHERS_DEFAULT_COLORS[dataIndex]
                        },
                        radius: ['50%', '80%'],
                        top: 0,
                        avoidLabelOverlap: true,
                        tooltip: {
                            show: true,
                            formatter: '<span style="font-size: 14px">{b} :</span> <b>{d}%</b>',
                            textStyle: {
                                fontFamily: 'weborama',
                                fontSize: 19,
                                color: '#000000',
                                extraCssText: 'box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.08)',
                                borderRadius: 10,
                            },
                            color: '#000000',
                            borderWidth: 0,
                        },
                        label: {
                            show: false,
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '14'
                            }
                        },
                        data: Object.entries(this.allocationMetrics.allocationBySignificantProvider).map(([name, value]) => ({ name, value }))
                    }
                ]
            }
        }
    }
}
</script>